import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-hidden-formly',
	template: `
		<input
			type="hidden"
			[formControl]="formControl | fromAbstractToFormControl"
			[attr.hasValue]="!!formControl?.value"
			[formlyAttributes]="field" />
	`
})
export class LuHiddenFormlyComponent extends FieldType {}
